import type { Content } from '@ei-tech/embedded-component';
import { hasNonEmpty } from '@thesavingsgroup/utils/hasNonEmpty';
import { StateCreator } from 'zustand';

import { GetEmbeddedInsuranceURLParams } from './types/GetEmbeddedInsuranceURLParams';
import { GetEmbeddedInsuranceVerificationURLParams } from './types/GetEmbeddedInsuranceVerificationURLParams';
import { ThirdPartyState } from './types/ThirdPartyState';
import { ThirdPartyStoreDependencies } from './types/ThirdPartyStoreDependencies';

export const thirdPartyStore =
  ({
    useApiStore,
  }: ThirdPartyStoreDependencies): StateCreator<ThirdPartyState> =>
  (set, get) => ({
    isEmbeddedInsuranceLayoutVisible: false,

    getEmbeddedInsuranceContent: (leadId: string) => {
      const portalHttpRequest = useApiStore.getState().portalApi();

      return portalHttpRequest
        .post<never, Content>('/2.0/third-party/embedded-insurance/content', {
          leadId,
        })
        .then((content) => {
          set({
            isEmbeddedInsuranceLayoutVisible:
              hasNonEmpty(content, ['layout']) && content.layout !== 'none',
          });

          return content;
        });
    },
    getEmbeddedInsuranceURL: (params: GetEmbeddedInsuranceURLParams) => {
      const portalHttpRequest = useApiStore.getState().portalApi();

      return portalHttpRequest
        .post<never, { url: string }>(
          '/2.0/third-party/embedded-insurance/link',
          params,
        )
        .then(({ url }) => url);
    },
    getEmbeddedInsuranceURLWithBrand: (partnerBrand: string) => {
      const { getEmbeddedInsuranceURL } = get();

      return (leadId: string) =>
        getEmbeddedInsuranceURL({ leadId, partnerBrand });
    },
    getEmbeddedInsuranceVerificationURL: (
      params: GetEmbeddedInsuranceVerificationURLParams,
    ) => {
      const portalHttpRequest = useApiStore.getState().portalApi();

      return portalHttpRequest
        .post<never, { url: string }>(
          '/2.0/third-party/embedded-insurance/verification-link',
          params,
        )
        .then(({ url }) => url)
        .catch(() => null);
    },
  });
